import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { Table, Dropdown, Menu, Button, Badge } from "antd";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useParams } from "react-router-dom";
import { EllipsisOutlined } from "@ant-design/icons";
import { ReactComponent as ResidentialLogo } from "../../Assets/Categories/ResidentialLogo.svg";
import { useSelector } from "react-redux";

const ViewCity = () => {
  const { id } = useParams();

  const [city, setCity] = useState();

  const [searchQuery, setSearchQuery] = useState();

  const { cities } = useSelector((state) => state.city);

  const filteredCities = cities?.data?.filter((city) =>
    city.city_name?.toLowerCase().includes((searchQuery || "").toLowerCase())
  );

  useEffect(() => {
    if (cities?.data) {
      const foundCity = cities.data.find((city) => city._id === id);
      console.log("Found city data:", foundCity);
      setCity(foundCity);
    }
  }, [cities, id]);

  const columns = [
    {
      title: "Cities",
      dataIndex: "city_name",
      align: "center",
      key: "country_name_withoutspace", 
    },
    // {
    //   title: "VR Home Visit",
    //   align: "center",
    //   dataIndex: "is_vr_home_visit_available",
    //   key: "is_vr_home_visit_available",
    //   render: (status) => (
    //     <span
    //       style={{
    //         display: "inline-flex",
    //         alignItems: "center",
    //         padding: "4px 8px",
    //         border: "1px solid #d9d9d9", // Light gray border
    //         borderRadius: "10px", // Rounded edges
    //       }}
    //     >
    //       <Badge
    //         color={status === "active" ? "green" : "red"}
    //         text={status}
    //         background
    //       ></Badge>
    //     </span>
    //   ),
    // },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9", // Light gray border
            borderRadius: "10px", // Rounded edges
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={status}
            background
          ></Badge>
        </span>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Link to={`/city/edit/${record._id}`}>
              <Menu>
                <Menu.Item>Edit</Menu.Item>
              </Menu>
            </Link>
          }
        >
          <Button shape="square" icon={<EllipsisOutlined />}></Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginTop: "10px", marginRight: "10px", width: "100%" }}>
        <SearchBar></SearchBar>
        <div style={{}}></div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            textAlign: "center",
            marginLeft: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "1vh" }}>
            <Link to="/city">
              <BackIcon style={{ cursor: "pointer" }} />
            </Link>
            <div>
              <h1 style={{ textAlign: "center" }}>
                {city?.city_name || "No Data"}
              </h1>

              <h4
                style={{
                  position: "relative",
                  top: "-10px",
                  fontFamily: "Gilroy-Medium",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "100",
                  lineHeight: "10px",
                  right: "20px",
                }}
              >
                State/ List/ View
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          gap: "20px",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <div
          style={{
            marginLeft: "2vh",
            padding: "10px",
            display: "inline-block",
            width: "552px",
            minHeight: "848px",
            background:
              "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
            borderRadius: "30px",
            flexDirection: "column",
            alignItems: "flex-start",
            position: "relative",
          }}
        >
          <button
            style={{
              position: "absolute",
              top: "50px",
              right: "70px",
              padding: "12px 24px",
              background:
                "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
              border: "1px solid white",
              borderRadius: "5px",
              cursor: "pointer",
              color: "white",
              fontFamily: "Gilroy-Bold",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "14.6px",
            }}
          >
            Edit
          </button>
          <ResidentialLogo
            style={{ position: "absolute", top: "50px", left: "39px" }}
          ></ResidentialLogo>
          <h1
            style={{
              position: "absolute",
              color: "white",
              top: "220px",
              left: "39px",
              marginTop: "36.81px",
            }}
          >
            {city?.city_name || "No Data"}
          </h1>
        </div>
        <span
          style={{ width: "100%", background: "white", borderRadius: "25px" }}
        >
          <div
            style={{
              marginLeft: "2vh",
              paddingTop: "30px",
              display: "flex",
              gap: "5%",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc", // Border around the search bar
                borderRadius: "25px",
                padding: "5px 15px",
                width: "auto", // Set the width of the search bar
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                style={{
                  padding: "10px",
                  width: "60vw",
                  borderRadius: "25px",
                  border: ".01px solid #ccc",
                  fontSize: "16px",
                  // marginRight: "20vh", // Space between search bar and button
                  outline: "none", // Remove default focus outline
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease", // Smooth transition for focus effect
                }}
                onFocus={(e) => {
                  e.target.style.border = ".01px solid #172358"; // Highlight border color on focus
                  e.target.style.boxShadow = "0 0 10px rgba(23, 35, 88, 0.5)"; // Light shadow effect
                }}
                onBlur={(e) => {
                  e.target.style.border = ".01px solid #ccc"; // Reset border when focus is lost
                  e.target.style.boxShadow = "none"; // Reset shadow effect
                }}
              />
            </div>
          </div>
          <div style={{ padding: "0px 60px" }}>
            <Table
              columns={columns}
              dataSource={filteredCities || []}
              rowKey="_id"
              pagination={{ pageSize: 15 }}
              style={{ marginTop: "2vh", flex: 1, width: "100%" }}
            />
          </div>
        </span>
      </div>
    </div>
  );
};

export default ViewCity;
